// extracted by mini-css-extract-plugin
export default {"cls1":"ENWJnk0WrUY5wL02m5Md","cls2":"Z0IW4e3rP4O2DFOpJpVH ENWJnk0WrUY5wL02m5Md"};